//let sitUrl = '/richin/sit'; // sit环境
let sitUrl = 'http://110.41.7.145:18088'; // sit环境
export { sitUrl };
